import { Box, Chip, IconButton, Tooltip, CircularProgress } from '@mui/material';
import {
  ArrowLeft as ArrowLeftIcon,
  ArrowRight as ArrowRightIcon,
  AccessTime as ClockIcon,
} from '@mui/icons-material';
import './TimelinePagination.css';

const TIME_OFFSETS = [
  { label: '-10 min', value: 10 },
  { label: '-5 min', value: 5 },
  { label: 'Event Time', value: 0 },
];

const TimelinePagination = ({
  currentPage,
  offsetMinutes,
  setOffsetMinutes,
  goToPreviousPage,
  goToNextPage,
  timelineTableQuery,
}) => {
  const isFetching = timelineTableQuery.isFetching;

  return (
    <Box className="time-navigator-shell">
      <Box className="time-navigator-label">Search Window</Box>
      <Box className="time-navigator">
      <Tooltip title="View earlier files">
        <span>
          <IconButton
            size="small"
            onClick={goToPreviousPage}
            disabled={isFetching}
            className="time-navigator-arrow"
          >
            {isFetching ? <CircularProgress size={16} /> : <ArrowLeftIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>

      <Box className="time-navigator-chips">
        {TIME_OFFSETS.map((offset) => (
          <Chip
            key={offset.label}
            label={offset.label}
            size="small"
            icon={offset.value === 0 ? <ClockIcon className="time-navigator-clock-icon" /> : undefined}
            variant={offsetMinutes === offset.value ? 'filled' : 'outlined'}
            color={offsetMinutes === offset.value ? 'primary' : 'default'}
            onClick={() => setOffsetMinutes(offset.value)}
            disabled={isFetching}
            className="time-navigator-chip"
          />
        ))}
      </Box>

      <Tooltip title="View later files">
        <span>
          <IconButton
            size="small"
            onClick={goToNextPage}
            disabled={isFetching}
            className="time-navigator-arrow"
          >
            {isFetching ? <CircularProgress size={16} /> : <ArrowRightIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
      </Box>
    </Box>
  );
};

export default TimelinePagination;
